import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 border-t border-brand-border bg-white text-center text-brand-muted text-sm" data-id="element-57">
      <div className="max-w-2xl mx-auto space-y-4" data-id="element-58">
        <p className="text-brand-primary font-heading font-bold uppercase tracking-wide text-base" data-id="element-59">
          Tiroide Felice™
        </p>
        <p className="text-xs" data-id="element-60">
          © Tiroide Felice 2026 — Tutti i diritti riservati.
        </p>
        <p className="text-xs text-brand-muted leading-relaxed" data-id="element-61">
          Avviso legale: Le informazioni fornite in questo materiale sono di
          natura educativa e non sostituiscono il parere medico professionale.
          Consulta sempre il tuo medico prima di apportare modifiche alla tua
          dieta o stile di vita, specialmente se stai assumendo farmaci per la
          tiroide.
        </p>
        <p className="text-xs" data-id="element-62">
          Assistenza:{' '}
          <a href="mailto:kitonline27@gmail.com" className="text-brand-accent hover:underline" data-id="element-63">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}